import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  LinearProgress,
  withStyles,
  createStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import styled from 'styled-components/macro';
import Button from 'app/shared/components/button/Button';
// import styledFuncs from 'app/styles/styledFuncs';
import { useIdentity } from 'app/core/api/company/api-company';
import ConsumerRoutePath from '../ConsumerRoutePath';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const Title = styled.h1`
  color: #31ad31;
  font-size: 15px;
  font-weight: 400;
  margin: 0;
`;
const SubTitle = styled.h1`
  color: #f6645b;
  font-weight: 400;
  font-size: 9px;
`;
const ProgressBlock = styled.div``;
const ProgressTitle = styled.h1`
  color: #000000;
  font-weight: 500;
  font-size: 10px;
`;
const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[
          theme.palette.type === 'light' ? 200 : 700
        ],
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#31ad31',
    },
  })
)(LinearProgress);

const CustomPaper = withStyles(() =>
  createStyles({
    root: {
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      borderRadius: 10,
    },
  })
)(Paper);

export default function MotorcycleCompetition(): JSX.Element {
  const { resource: identity } = useIdentity();
  const [compProdCount, setCompProdCount] = useState<number>(0);
  // const [compRefCount, setCompRefCount] = useState<number>(0);
  const [compEntryCount, setCompEntryCount] = useState<number>(0);
  useEffect(() => {
    if (identity) {
      setCompProdCount(identity.compProdCount);
      // setCompRefCount(identity.refCount);
      setCompEntryCount(identity.compEntryCount);
    }
  }, [identity]);
  return (
    <Container>
      <Title>Motorcycle Live Competition 2022</Title>
      <SubTitle>
        Available for UK residents only from 12 Nov to 11 Dec 2022.
      </SubTitle>
      {compProdCount >= 3 ? (
        <CustomPaper square={false}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              paddingBottom: '15px',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <div style={{ width: '70%', padding: '0 10px' }}>
              <p
                style={{
                  fontWeight: 500,
                  fontSize: '13px',
                  color: '#000000',
                  marginBottom: '0px',
                }}
              >
                Congratulations on entering the giveaway
              </p>

              <p
                style={{
                  fontWeight: 500,
                  fontSize: '13px',
                  color: '#000000',
                  marginTop: '5px',
                }}
              >
                Refer more friends to increase your chances
              </p>

              <Button
                style={{ fontWeight: 500 }}
                to={ConsumerRoutePath.REFER}
              >
                Invite more friends
              </Button>
            </div>
            <div
              style={{
                width: '30%',
                padding: '0 10px',
                textAlign: 'center',
              }}
            >
              <p
                style={{
                  fontSize: '50px',
                  fontWeight: 500,
                  color: '#31AD31',
                  margin: 0,
                }}
              >
                {compEntryCount || '0'}
              </p>
              <p
                style={{
                  color: '#000000',
                  fontSize: '15px',
                  fontWeight: 500,
                }}
              >
                {compEntryCount <= 1 && 'Entry'}
                {compEntryCount > 1 && 'Entries'}
              </p>
            </div>
          </div>
        </CustomPaper>
      ) : (
        <CustomPaper
          square={false}
          style={{ padding: '5px 10px 10px 10px' }}
        >
          <ProgressBlock>
            <ProgressTitle>Products uploaded</ProgressTitle>
            <Box display="flex" alignItems="center">
              <Box width="100%" mr={1}>
                <BorderLinearProgress
                  variant="determinate"
                  value={
                    compProdCount === 1
                      ? 33
                      : compProdCount === 2
                      ? 66
                      : compProdCount === 3
                      ? 100
                      : 0
                  }
                />
              </Box>
              <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">
                  {compProdCount || '0'}
                  /3
                </Typography>
              </Box>
            </Box>
          </ProgressBlock>
          {/* <ProgressBlock>
            <ProgressTitle>Friends referred</ProgressTitle>
            <Box display="flex" alignItems="center">
              <Box width="100%" mr={1}>
                <BorderLinearProgress
                  variant="determinate"
                  value={compRefCount === 1 ? 100 : 0}
                />
              </Box>
              <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">
                  {compRefCount || '0'}/1
                </Typography>
              </Box>
            </Box>
          </ProgressBlock> */}
        </CustomPaper>
      )}
    </Container>
  );
}
